import React, { useCallback, useState } from 'react';

import { MenuItem } from '@material-ui/core';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import DropdownListElements from 'components/DropdownListElements/DropdownListElements';
import NoDataComponent from 'components/NoDataComponent';
import styled, { css } from 'styled-components';
import { isEmptyObject } from 'styles/common';

import { HashTagIcon } from 'constants/icons';
import theme from 'constants/theme';

import FilterDisplay from './FilterDisplay';
import { getFunctionForSortingSelectedAtTop } from './helper';
import { ScrollableContainer } from './styles';

const StyledDropdownList = styled(DropdownList)`
  margin-top: 15px;
  ${(props) => css`
    &:after {
      content: ' ';
      width: 0px;
      height: 10px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 9px solid ${theme.palette.background.paper};
      display: inline-block;
      position: absolute;
      transform: rotate(180deg);
      left: 30%;
      top: -10px;
      z-index: 999;
    }
  `};
`;

const DropdownListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const TAG_FILTER_SELECT = 'TAG_FILTER_SELECT';
const TAG_FILTER_UPDATE = 'TAG_FILTER_UPDATE';
const TAG_FILTER_CLEAR = 'TAG_FILTER_CLEAR';
export const initialTagFilters = {};

export function buildTagFilters(selectedEmployees) {
  const ids = Object.entries(selectedEmployees).reduce((employeeIds, [employeeId, isSelected]) => {
    if (isSelected) employeeIds.push(employeeId);
    return employeeIds;
  }, []);
  return ids.map((id) => ({ type: 'TAGS', value: id, operator: 'IN' }));
}

export function tagFilterReducer(state = {}, action) {
  switch (action.type) {
    case TAG_FILTER_SELECT: {
      const newState = { ...state };
      newState[action.value] = !newState[action.value];
      return newState;
    }
    case TAG_FILTER_UPDATE: {
      return { ...action.values };
    }
    case TAG_FILTER_CLEAR: {
      return {};
    }
    default:
      return state;
  }
}

export default function TagFilter({ selectedFiltersDispatch, selectedFilters, taskTags = [], width = '20%' }) {
  const [selected, setSelected] = useState({});

  const filterIds = Object.entries(selectedFilters).reduce((ids, [value, isSelected]) => {
    isSelected && ids.push(value);
    return ids;
  }, []);

  function makeCurrentStateEqualToSelectedState() {
    const selected = {};
    filterIds.forEach((id) => (selected[id] = true));
    setSelected(selected);
  }

  function onSelect(value) {
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  }

  const onApply = useCallback(() => {
    selectedFiltersDispatch({ type: TAG_FILTER_UPDATE, values: { ...selected } });
    // document.body.click();
  }, [selected, TAG_FILTER_UPDATE]);

  const onClickAway = useCallback(() => {
    if (isEmptyObject(selected)) {
      return null;
    }
    onApply();
  }, [selected, onApply]);

  const onClear = (e) => {
    e.stopPropagation();
    setSelected({});
    selectedFiltersDispatch({ type: TAG_FILTER_CLEAR });
    document.body.click();
  };

  const selectedCount = filterIds.length;

  const selectedAtTopTaskTags = taskTags.sort(getFunctionForSortingSelectedAtTop(selected));

  return (
    <CustomMenu
      icon={
        <FilterDisplay
          width={width}
          icon={<HashTagIcon padding="1px" />}
          name="Tags"
          selectedCount={selectedCount}
          onClear={onClear}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
      onClickAway={onClickAway}
      menuType="tag_filter"
    >
      {taskTags.length === 0 ? (
        <StyledNoDataComponent message=" No tags present" />
      ) : (
        <StyledDropdownList>
          <ScrollableContainer>
            {selectedAtTopTaskTags.map((tags, index) => (
              <MenuItem onClick={onSelect.bind(null, tags.value)} value={tags.value} style={{ padding: 0 }} key={index}>
                {/* <Checkbox checked={Boolean(selected[tags.value])} color="primary" /> */}
                <DropdownListWrapper>
                  <DropdownListElements label={tags.label} checked={Boolean(selected[tags.value])} />
                </DropdownListWrapper>
                {/* <StyledTypography display="inline">{tags.label}</StyledTypography> */}
              </MenuItem>
            ))}
          </ScrollableContainer>
          {/* <ApplyMenuItem onClick={onApply}>
            <StyledTypography color="primary">Apply</StyledTypography>
          </ApplyMenuItem> */}
        </StyledDropdownList>
      )}
    </CustomMenu>
  );
}

const StyledNoDataComponent = styled(NoDataComponent)`
  min-height: 20vh;
`;
